import React, { useEffect, useState } from 'react';
import css from './ListingsSection.module.css';
import { useConfiguration } from '../../../../context/configurationContext';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { getListingsById } from '../../../../ducks/marketplaceData.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../../../ducks/ui.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SearchResultsPanel from '../../../SearchPage/SearchResultsPanel/SearchResultsPanel';
import { parse } from '../../../../util/urlHelpers';
import { Button } from '../../../../components';
import useScrollRestoration from './useScrollRestauration';

const generateRandomPercentages = () => {
  // Set a minimum percentage
  const minPercentage = 20;

  // Generate three random numbers
  let random1 = Math.random();
  let random2 = Math.random();
  let random3 = Math.random();

  // Normalize the random values to sum to 1
  let totalRandom = random1 + random2 + random3;
  let percentage1 = (random1 / totalRandom) * (100 - 3 * minPercentage) + minPercentage;
  let percentage2 = (random2 / totalRandom) * (100 - 3 * minPercentage) + minPercentage;
  let percentage3 = (random3 / totalRandom) * (100 - 3 * minPercentage) + minPercentage;

  // Return as formatted strings
  return [`${percentage1.toFixed(2)}%`, `${percentage2.toFixed(2)}%`, `${percentage3.toFixed(2)}%`];
};

const ListingsSectionComponent = ({ listings, location }) => {
  const [hide, setHide] = useState(true);
  useEffect(() => {
    setHide(true);
    setTimeout(() => {
      setHide(false);
    }, 200);
  }, [location?.search]);

  const history = useHistory();
  useScrollRestoration();
  if (hide) return <div className={css.placeholder}></div>;
  if (!listings || listings.length < 1) return null;

  const images = listings
    .filter((l) => l?.images[0])
    .map((l) => ({
      to: `/l/${l?.attributes?.title?.replaceAll(' ', '-')}/${l.id.uuid}`,
      image: l?.images[0] && l?.images[0]?.attributes?.variants?.['listing-card-2x']?.url,
    }));

  // Group images into chunks of three
  const groupedImages = images.reduce((acc, curr, index) => {
    if (index % 3 === 0) acc.push([]);
    acc[acc.length - 1].push(curr);
    return acc;
  }, []);

  return (
    <div className={css.wrapper}>
      <div className={css.imagesWrapper}>
        {groupedImages.map((group, groupIndex) => {
          const widths = generateRandomPercentages();
          return group.map((img, imgIndex) => (
            <img
              key={`${groupIndex}-${imgIndex}`}
              src={img.image}
              className={css.listingImage}
              style={{ width: `calc(${widths[imgIndex]} - 8px)` }}
              onClick={() => history.push(img.to)}
            />
          ));
        })}
      </div>
      <Button className={css.viewAllButton} onClick={() => history.push('/s')}>
        View all
      </Button>
    </div>
  );
};

const EnhancedListingsSection = (props) => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  const { currentUser, ...restOfProps } = props;

  return (
    <ListingsSectionComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...restOfProps}
    />
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state.user;
  const { currentPageResultIds, pagination, searchInProgress, searchListingsError, searchParams } =
    state.SearchPage;
  const listings = getListingsById(state, currentPageResultIds);

  return {
    currentUser,
    listings,
    pagination,
    scrollingDisabled: isScrollingDisabled(state),
    searchInProgress,
    searchListingsError,
    searchParams,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingsSection = compose(connect(mapStateToProps, mapDispatchToProps))(
  EnhancedListingsSection
);

export default ListingsSection;
